// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Fix UTF-8 encoding issues
export const fixEncoding = (text) => {
  if (!text) return text;
  
  const replacements = {
    'Ã©': 'é',
    'Ã¨': 'è',
    'Ãª': 'ê',
    'Ã«': 'ë',
    'Ã ': 'à',
    'Ã¢': 'â',
    'Ã¤': 'ä',
    'Ã´': 'ô',
    'Ã¶': 'ö',
    'Ã¹': 'ù',
    'Ã»': 'û',
    'Ã¼': 'ü',
    'Ã§': 'ç',
    'Ã±': 'ñ',
    'Ã‰': 'É',
    'Ãˆ': 'È',
    'ÃŠ': 'Ê',
    'Ã€': 'À',
    'Ã‚': 'Â',
    'Ã"': 'Ô',
    'Ã‡': 'Ç',
    'Å"': 'œ',
    'Å ': 'Š',
    'Å¡': 'š',
    'Å¸': 'Ÿ',
    'Å½': 'Ž',
    'Å¾': 'ž',
    'Ã¯': 'ï',
    'Ã®': 'î',
    'Ã¬': 'ì',
    'Ã­': 'í',
    'Ã\u0091': 'Ñ',
    'Ã"': 'Ó',
    'Ã\u0092': 'Ò',
    'Ã•': 'Õ',
    'Ã–': 'Ö',
    'Ãš': 'Ú',
    'Ã™': 'Ù',
    'Ã›': 'Û',
    'Ãœ': 'Ü',
    'Ã½': 'ý'
  };
  
  let fixed = text;
  for (const [wrong, correct] of Object.entries(replacements)) {
    fixed = fixed.replace(new RegExp(wrong, 'g'), correct);
  }
  
  return fixed;
};

// SEO Meta Tags Component
export const SEO_CONFIG = {
  siteName: 'Marques & Co',
  defaultTitle: 'Marques & Co - Comparez les prix des meilleures marques',
  defaultDescription: 'Trouvez les meilleures offres et comparez les prix de milliers de produits de vos marques préférées. Samsung, Apple, Dyson, Adidas et plus encore.',
  defaultKeywords: 'comparateur prix, meilleures offres, promotions, marques, Samsung, Apple, Dyson, Adidas',
  siteUrl: process.env.REACT_APP_BACKEND_URL || 'https://marques-and-co.com',
  locale: 'fr_FR',
  type: 'website'
};
